import { AvField, AvForm } from "availity-reactstrap-validation"
import { map } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

import { createInvestmentLead, updateInvestmentLead } from "store/actions"

export const MEDIUM_OPTIONS = [
  { label: "Social Media", value: "social" },
  { label: "Walk-In", value: "direct" },
  { label: "Call", value: "call" },
  { label: "Website", value: "website" },
  { label: "OLX", value: "olx" },
]

export const TYPE_OPTIONS = [
  { label: "Invest", value: "invest" },
  { label: "Franchisee", value: "franchisee" },
]

export const LEAD_CONDITION = {
  SUPER_HOT: 'superHot',
  HOT: 'hot',
  WARM: 'warm',
  NORMAL: 'normal',
}

export const LEAD_CONDITION_OPTIONS = [
  { label: "Super Hot", value: "superHot" },
  { label: "Hot", value: "hot" },
  { label: "Warm", value: "warm" },
  { label: "Normal", value: "normal" },
]

const InvestmentLeadModal = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()

  const [medium, setMedium] = useState("")
  const [type, setType] = useState("")
  const [leadCondition, setLeadCondition] = useState(LEAD_CONDITION.NORMAL)

  const handleMediumValues = value => {
    setMedium(value)
  }
  const handleTypeValues = value => {
    setType(value)
  }
  const handleLeadConditionValues = value => {
    setLeadCondition(value)
  }

  const STATUS_OPTIONS = [
    { label: "New", value: "new" },
    { label: "Process", value: "process" },
    { label: "Win", value: "win" },
    { label: "Lost", value: "lost" },
  ]

  const handleValidSubmit = (e, v) => {
    const iLeadPayload = {
      name: v.name,
      phone: v.phone,
      note: v.note,
      occupation: v.occupation,
      place: v.place,
      medium: medium,
      type: type,
      leadCondition: leadCondition,
    }

    const iLeadUpdatePayload = {
      ...iLeadPayload,
      status: v.lead_status,
    }

    if (updateData?._id) {
      dispatch(
        updateInvestmentLead(iLeadUpdatePayload, updateData?._id, onCloseClick)
      )
    } else {
      dispatch(createInvestmentLead(iLeadPayload, onCloseClick))
    }
  }

  // todo : Create and update and delete api connection
  // todo : status update and type,medium,status filter in table list

  useEffect(() => {
    if (updateData?._id) {
      setMedium(updateData?.medium)
      setType(updateData?.type)
      setLeadCondition(updateData?.leadCondition || LEAD_CONDITION.NORMAL)
    }
  }, [updateData])

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg">
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id
            ? "Edit Investment Lead Details"
            : "Add New Investment Lead"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <Col className="col-6 mb-2">
              <label>
                Name <span className="text-danger"> *</span>
              </label>
              <AvField
                name="name"
                type="text"
                placeholder="Enter name"
                value={updateData?.name}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Name is required",
                  },
                }}
              />
            </Col>
            <Col className="col-6">
              <label>Phone</label>
              <AvField
                name="phone"
                type="text"
                placeholder="Enter phone"
                value={updateData?.phone}
              />
            </Col>

            <Col className="col-6 mt-2">
              <label>Note</label>
              <AvField
                name="note"
                type="textarea"
                placeholder="Enter note"
                value={updateData?.note}
                multiline
                rows="5"
              />
            </Col>
            <Col className="col-6 mt-2">
              <label>Occupation</label>
              <AvField
                name="occupation"
                type="text"
                placeholder="Enter occupation"
                value={updateData?.occupation}
              />
              <div className="mt-2">
                <label>Place</label>
                <AvField
                  name="place"
                  type="text"
                  placeholder="Enter place"
                  value={updateData?.place}
                />
              </div>
            </Col>

            <Col md="8" style={{ marginTop: "5px" }}>
              <label className="my-2">Medium</label>&nbsp;
              <div
                className="btn-group mt-0 mt-xl-0 d-flex align-items-center justify-content-start"
                role="group"
                aria-label="Basic radio toggle button group"
              >
                {map(MEDIUM_OPTIONS, (item, key) => (
                  <div key={key} className="mx-1">
                    <input
                      type="radio"
                      className="btn-check"
                      name="btnradio-medium"
                      id={item.value + "medium-create"}
                      autoComplete="off"
                      checked={medium === item.value}
                      value={item.value}
                      onChange={e => handleMediumValues(e.target.value)}
                    />
                    <label
                      className="btn btn-outline-warning"
                      htmlFor={item.value + "medium-create"}
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </Col>

            <Col md="4" style={{ marginTop: "5px" }}>
              <label className="my-2">Type</label>&nbsp;
              <div
                className="btn-group mt-0 mt-xl-0 d-flex align-items-center justify-content-start"
                role="group"
                aria-label="Basic radio toggle button group"
              >
                {map(TYPE_OPTIONS, (item, key) => (
                  <div key={key} className="mx-1">
                    <input
                      type="radio"
                      className="btn-check"
                      name="btnradio-type"
                      id={item.value + "type-create"}
                      autoComplete="off"
                      checked={type === item.value}
                      value={item.value}
                      onChange={e => handleTypeValues(e.target.value)}
                    />
                    <label
                      className="btn btn-outline-warning"
                      htmlFor={item.value + "type-create"}
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </Col>

            <Col md="12" style={{ marginTop: "5px" }}>
              <label className="my-2">Lead Condition</label>&nbsp;
              <div
                className="btn-group mt-0 mt-xl-0 d-flex align-items-center justify-content-start"
                role="group"
                aria-label="Basic radio toggle button group"
              >
                {map(LEAD_CONDITION_OPTIONS, (item, key) => (
                  <div key={key} className="mx-1">
                    <input
                      type="radio"
                      className="btn-check"
                      name="btnradio-leadCondition"
                      id={item.value + "leadCondition-create"}
                      autoComplete="off"
                      checked={leadCondition === item.value}
                      value={item.value}
                      onChange={e => handleLeadConditionValues(e.target.value)}
                    />
                    <label
                      className="btn btn-outline-warning"
                      htmlFor={item.value + "leadCondition-create"}
                    >
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>
            </Col>

            {/* <Col className="col-4 mt-2">
              <label>Medium</label>
              <AvField type="select" name="medium" value={updateData?.medium}>
                {MEDIUM_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </AvField>
            </Col> */}
          </Row>

          <hr />

          {updateData?._id && (
            <Col className="col-4 mt-2">
              <label>Status</label>
              <AvField
                type="select"
                name="lead_status"
                value={updateData?.status}
              >
                {STATUS_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </AvField>
            </Col>
          )}

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

InvestmentLeadModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default InvestmentLeadModal
